<template>
    <ConsultaPublica
        titulo="Cartelas"
        placeholder="Bilhete ou nº da cartela"
        :mostrar-busca="$route.name !== 'cartela-detalhes'"
        v-model:termo="stateCartelas.pesquisarCartela"
        :loading="stateCartelas.loading.carregarCartela"
        :error-message="stateCartelas.errorMessage"
        :aviso="aviso"
        :dados="dados"
        :referencias="referencias"
        :grupos="grupos"
        :rounds="stateCartelas.bilhete.rounds"
        @pesquisar="carregarCartelas()"
    />
</template>

<script>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import useCartelas from '../../composables/useCartelas'
import ConsultaPublica from '../../components/ConsultaPublica.vue'
import { formatarParaReais, formatarData } from '../../utilities/formato'

export default {

    components:{ConsultaPublica},

    setup(){

        const route = useRoute()

        //composables
        const {stateCartelas,carregarCartelas} = useCartelas()

        //pega o token e coloac na rota
        if(route.params.token){
            stateCartelas.pesquisarCartela = route.params.token
        }

        //loads
        if(route.name === 'cartela-detalhes'){
            carregarCartelas()
        }

        const bilhete = computed(() => stateCartelas.bilhete)

        const cartelas = computed(() => bilhete.value.games || [])

        const aviso = computed(() => {
            if (bilhete.value.hasWinner) {
                return {
                    tom: bilhete.value.wonAccumulatedPrize ? 'acumulado' : 'destaque',
                    icone: bilhete.value.wonAccumulatedPrize ? 'pi pi-star' : 'pi pi-check-circle',
                    titulo: bilhete.value.wonAccumulatedPrize ? 'Ganhou o acumulado' : 'Bilhete premiado',
                    detalhe: bilhete.value.totalPrizeWon
                        ? { rotulo: 'Total recebido', valor: formatarParaReais(bilhete.value.totalPrizeWon) }
                        : null
                }
            }

            if (cartelas.value.length && !bilhete.value.drawEnded) {
                return {
                    tom: 'neutro',
                    icone: 'pi pi-clock',
                    titulo: 'Sorteio ainda não finalizado',
                    detalhe: null
                }
            }

            return null
        })

        const dados = computed(() => {
            const valorDaCartela = cartelas.value.length ? cartelas.value[0].paidValue : 0

            return [
                { rotulo: 'Local', valor: bilhete.value.establishment || '-' },
                { rotulo: 'Data', valor: formatarData(bilhete.value.date) },
                { rotulo: 'Cartelas', valor: `${cartelas.value.length} · ${formatarParaReais(cartelas.value.length * valorDaCartela)}` },
            ]
        })

        const referencias = computed(() => [
            bilhete.value.id && `Sorteio ${bilhete.value.id}`,
            bilhete.value.shareToken && `Bilhete ${bilhete.value.shareToken}`,
        ].filter(Boolean))

        // As cartelas já chegam ordenadas com as premiadas na frente, aqui elas apenas são separadas em blocos
        const grupos = computed(() => {
            const premiadas = cartelas.value.filter(game => game.winner)
            const demais = cartelas.value.filter(game => !game.winner)

            if (!premiadas.length) {
                return [{ titulo: null, cartelas: demais }]
            }

            const grupos = [{ titulo: 'Premiadas', cartelas: premiadas }]

            if (demais.length) {
                grupos.push({ titulo: 'Demais cartelas', cartelas: demais })
            }

            return grupos
        })

        return{
            stateCartelas,
            aviso,
            dados,
            referencias,
            grupos,
            carregarCartelas,
        }
    }
}
</script>
